import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, mergeProps as _mergeProps, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = {
  class: "x-kpi-table-header"
};
import KpiTableTd from './kpiTableTd.vue';
import { computed, toRefs } from 'vue';
import { useKpiTableColumns } from '../kpiTableColumns';
export default {
  __name: 'kpiTable',
  props: {
    layers: {
      type: Number,
      default: 3
    },
    rows: {
      type: Array,
      default: () => []
    },
    editable: {
      type: Boolean,
      default: false
    },
    // 是否可编辑
    fields: {
      type: Object,
      default: () => ({})
    },
    colspan: {
      type: Function
    },
    columnWidths: {
      type: Array,
      default: () => ['width:80px', 'width:100px', 'width:150px', 'width:220px', 'width:170px', 'width:220px']
    },
    headerBgColor: {
      type: [String, Number],
      default: '#d9d9d9'
    }
  },
  setup(__props) {
    const props = __props;
    const {
      rows
    } = toRefs(props);
    const {
      columns
    } = useKpiTableColumns(props);
    const columnWidths = computed(() => props.columnWidths || []);
    const isEditMode = computed(() => props.editable);

    // headerColspan 头表列合并属性
    const headerColspan = computed(() => (column, colIndex) => {
      if (props.colspan && typeof props.colspan === 'function') {
        const span = props.colspan(column, colIndex);
        if (span) {
          return {
            colspan: span
          };
        }
      }
      return {};
    });

    // 数据行列合并属性
    const rowColspan = computed(() => (column, colIndex, record) => {
      if (props.colspan && typeof props.colspan === 'function') {
        return props.colspan(column, colIndex, record);
      }
      return null;
    });
    const headerStyle = computed(() => {
      return {
        textAlign: 'center',
        backgroundColor: props.headerBgColor
      };
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("table", {
        class: _normalizeClass({
          'x-kpi-table': true,
          'x-kpi-table-edit': isEditMode.value
        })
      }, [_renderSlot(_ctx.$slots, "colgroup", {}, () => [columnWidths.value.length > 0 ? (_openBlock(), _createElementBlock("colgroup", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columnWidths.value, (w, idx) => {
        return _openBlock(), _createElementBlock("col", {
          key: idx,
          style: _normalizeStyle(w)
        }, null, 4);
      }), 128))])) : _createCommentVNode("", true)]), _createElementVNode("thead", null, [_renderSlot(_ctx.$slots, "tableHeader")]), _createElementVNode("tbody", null, [_renderSlot(_ctx.$slots, "header"), _createElementVNode("tr", _hoisted_2, [_renderSlot(_ctx.$slots, "tableHeader", {}, () => [_renderSlot(_ctx.$slots, "headPrefixRender"), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columns), (column, index) => {
        return _openBlock(), _createElementBlock("td", _mergeProps({
          class: "x-kpi-table-header-cell",
          key: `column_${index}`,
          style: headerStyle.value
        }, {
          ref_for: true
        }, headerColspan.value(column, index)), [_renderSlot(_ctx.$slots, column.field, {
          label: column.title,
          field: column.field,
          column: column,
          index: index
        }, () => [_createTextVNode(_toDisplayString(column.title), 1)])], 16);
      }), 128)), _renderSlot(_ctx.$slots, "headSuffixRender")])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rows), (record, index) => {
        return _openBlock(), _createElementBlock("tr", {
          key: `row_${index}`,
          class: "x-kpi-table-data-row"
        }, [_renderSlot(_ctx.$slots, "rowRender", {
          record: record,
          index: index
        }, () => [_renderSlot(_ctx.$slots, "rowPrefixRender", {
          row: record,
          index: index
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(columns), (column, colIndex) => {
          return _renderSlot(_ctx.$slots, "cellRender", {
            key: `column_${index}_${colIndex}`,
            record: record,
            rowIndex: index,
            colIndex: colIndex,
            column: column
          }, () => [_createVNode(KpiTableTd, {
            column: column,
            row: record,
            colspan: rowColspan.value(column, colIndex, record)
          }, {
            value: _withCtx(({
              Component
            }) => [_renderSlot(_ctx.$slots, `${column.field}_value`, {
              Component: Component,
              record: record,
              column: column,
              index: index
            }, () => [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))])]),
            extra: _withCtx(() => [_renderSlot(_ctx.$slots, `${column.field}_extra`, {
              column: column,
              record: record,
              index: index
            })]),
            _: 2
          }, 1032, ["column", "row", "colspan"])]);
        }), 128)), _renderSlot(_ctx.$slots, "rowSuffixRender", {
          record: record,
          index: index
        })])]);
      }), 128)), _renderSlot(_ctx.$slots, "footer")])], 2);
    };
  }
};